<template>
  <div class="btns">
    <div class="box-p-20 d-flex justify-content-end align-items-center">
      <div class="d-flex align-items-center" v-if="!fastShow">
        <select v-model="count" class="mr-3 select_no">
          <option value="0">0</option>
          <option v-for="num in parseInt(limit)" :value="num" :key="num">
            {{ num }}
          </option>
        </select>
        個
      </div>
      <div class="ml-5" v-if="!fastShow">
        <button type="button" class="btn" v-on:click="addToCart">
          カートに入れる
        </button>
      </div>
    </div>
  </div>

  <div v-html="innerHtml" />

  <section class="sec-cmn-02 text-center">
    <router-link class="btn" to="/products">商品一覧へ戻る</router-link>
  </section>
  <section class="sec-cmn-02 text-center">
    <router-link class="btn" to="/shoppingguide">ショッピングガイド</router-link>
  </section>

  <Cart ref="cart" />
</template>

<script>
import axios from "axios";
import Request from "@/modules/Request";
import Message from "@/modules/Message";
import $ from "jquery";

import Cart from "./components/Cart";

let request = new Request();

export default {
  components: {
    Cart,
  },
  mounted() {
    window.scroll(0, 0);
    let productNo = this.$route.params["productNo"];
    let title = this.$route.query.title;
    let limit = this.$route.query.limit;
    let type = this.$route.query.type;
    let code = this.$route.query.code;
    var today = new Date(Date.now());
    var targetDay = new Date(2022, 10, 30, 16 , 0, 0)
    var check = today < targetDay
    if(productNo == '155' && check){
      this.fastShow = true;
    }

    let ok = true;
    if (!productNo && productNo == "") ok = false;
    if (!limit && limit == "") ok = false;
    if (!type && type == "") ok = false;
    if (!code && code == "") ok = false;

    if (!ok) {
      Message.error()
        .fire({
          title: "パラメータが不正です",
        })
        .then(() => {
          this.$router.push("/products");
        });
      return false;
    }

    this.productNo = productNo;
    this.title = title;
    this.limit = limit;
    this.type = type;
    this.code = code;

    // 該当HTMLを取得しにいく
    axios
      .get(
        process.env.VUE_APP_CONTENTS_PRODUCT_HOME +
          this.productNo +
          "/template.html?"+new Date().getTime()
      )
      .then((res) => {
        this.innerHtml = res.data;
        $(function(){
          $('.list-detail dt').on('click', function() {
            $(this).toggleClass('is-active');
            $(this).next().slideToggle('fast');
          });
        });
      })
      .catch(() => {
        Message.create()
          .error({
            title: "商品ページが存在しません",
          })
          .then(() => {
            this.$router.push("/products");
          });
      });
      this.$refs.cart.loadCart();
  },
  data() {
    return {
      productNo: "",
      title: "",
      limit: "",
      type: "",
      code: "",
      count: 0,
      innerHtml: "",
      fastShow :false,
    };
  },
  methods: {
    addToCart() {
      let postParams = [this.type, this.code, this.count];
      let requestParams = request.createParams(
        "webMdlCart",
        "putCart",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          Message.success().fire({
            title: "カートに商品を追加しました",
            text: this.title + " : " + this.count + "個",
          });
          this.$store.commit("refreshCart", "");
          // 選択したカウントを初期化する
          this.count = 0;
          this.$refs.cart.loadCart();
        });
    },
  },
};
</script>